export default "__VITE_ASSET__BqkBxQF1__"